import React from 'react'
import PropTypes from 'prop-types'
import { useNavigate, useLocation } from 'react-router-dom'
import MasterData from '../../data/MasterData'
import { tidTrainKindClass } from '../../utils/ClassHelper'

const TRAIN_DIRECTION_CLASS = {
  'up': 'is_up',
  'down': 'is_down'
}

const Train = ({ train, intl }) => {
  const locale = intl.locale
  const navigate = useNavigate()
  const location = useLocation()

  const getDelayElement = () => {
    if (MasterData.isEdgeStation(train.station_id)) {
      return ''
    } else if (100 <= train.delay) {
      return <p className="d-TrainPosition-trainDelay is_text">{intl.formatMessage({id: 'App.Train.significantlyDelayed'})}</p>
    } else if (1 <= train.delay && train.delay <= 99) {
      return <p className="d-TrainPosition-trainDelay">{train.delay}</p>
    } else {
      return ''
    }
  }

  const handleTrainClick = () => {
    navigate(`${location.pathname}/${train.train_number}`)
  }

  const kind = MasterData.trainKindById(train.train_kind_id)

  return (
    <a className={`d-TrainPosition-train ${tidTrainKindClass(train)} ${TRAIN_DIRECTION_CLASS[train.direction]}`} onClick={handleTrainClick}>
      <div className="d-TrainPosition-trainBody">
        <div className="d-TrainPosition-trainMark">{kind[`abbr_name_${locale}`]}</div>
      </div>
      {getDelayElement()}
    </a>
  )
}

Train.propTypes = {
  train: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
}

export default Train
